import {
  BAND_ACTIONS,
  BandSettingsDataKeys,
  BandSettingsSlugs,
  BandSettingsType,
} from "Bands/types";
import { IDataKeys } from "shared/types";

const mapSlugs = {
  [IDataKeys.eventInfoBlockTypes]: BandSettingsSlugs.event_info_block_types,
  [IDataKeys.eventTypes]: BandSettingsSlugs.event_types,
  [IDataKeys.eventTicketAndPassTypes]:
    BandSettingsSlugs.event_ticket_and_pass_types,
  [IDataKeys.memberCategories]: BandSettingsSlugs.band_member_categories,
};

const mapActions = {
  [IDataKeys.eventInfoBlockTypes]: BAND_ACTIONS.editInfoBlockTypes,
  [IDataKeys.eventTypes]: BAND_ACTIONS.editEventTypes,
  [IDataKeys.eventTicketAndPassTypes]: BAND_ACTIONS.editTicketAndPassTypes,
  [IDataKeys.memberCategories]: BAND_ACTIONS.editMemberCategories,
};

const mapTypes = {
  [IDataKeys.eventInfoBlockTypes]: BandSettingsType.eventInfoBlockType,
  [IDataKeys.eventTypes]: BandSettingsType.eventType,
  [IDataKeys.eventTicketAndPassTypes]: BandSettingsType.eventTicketAndPassType,
  [IDataKeys.memberCategories]: BandSettingsType.bandMemberCategory,
};

export const getBandSettingSlugFromKey = (
  key: BandSettingsDataKeys
): BandSettingsSlugs => mapSlugs[key];

export const getBandSettingActionFromKey = (key: BandSettingsDataKeys) =>
  mapActions[key];

export const getBandSettingTypeFromKey = (key: BandSettingsDataKeys) =>
  mapTypes[key];
